







import Vue from "vue";
import CloudSettingEdit from "@/components/CloudSettings/CloudSettingEdit.vue";
import gridResult from "@/components/CloudSettings/DeviceSettingsGrid.vue";
import { Info } from "@/models/Info";
import { CloudSetting } from "../models/CloudSetting";

export default Vue.extend({
  name: "CloudSetting",
  components: {
    gridResult,
    CloudSettingEdit
  },
  props: {
    info: {
      type: Object as () => Info,
      default: null
    }
  },
  data() {
    return {
      editValue: null as CloudSetting | null,
      editModalVisible: false
    };
  },
  methods: {
    showEditModal(item: CloudSetting) {
      this.editValue = item;
      this.editModalVisible = true;
    },
    handleEditSuccess() {
      this.$emit("refresh");
    }
  }
});
